// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__zMyYC"};